export default __webpack_public_path__ + "static/media/superscreen.inline.d9a3e08c.svg";